import boldTextIcon from '../../assets/img/bold-text-format.svg';
import hyperlinkIcon from '../../assets/img/hyperlink.svg';
import hyperlinkUnlinkIcon from '../../assets/img/hyperlink_unlink.svg';
import italicTextIcon from '../../assets/img/italic-text-format.svg';
import listOrderedIcon from '../../assets/img/list-ordered.svg';
import listUnorderedIcon from '../../assets/img/list-unordered.svg';
import strikethroughTextIcon from '../../assets/img/strikethrough-text-format.svg';
import textColorIcon from '../../assets/img/text-color.svg';
import { BNS3_CHARITY_LOT_CATEGORY_ID } from '../../constants';
import styles from './styles.module.scss';

export const getInitialValues = (step, defaultLocationId, defaultCurrency) => ({
  lotType: '',
  lotState: '',
  productType: '',
  categoryId: step === 1 ? BNS3_CHARITY_LOT_CATEGORY_ID : '',
  subcategoryId: '',
  tagIds: [],
  title: '',
  locationId: defaultLocationId || null,
  fixedPrice: '',
  currency: defaultCurrency || null,
  lotImages: [],
  mainImageIndex: 0,
});

export const toolbarConfig = {
  options: ['colorPicker', 'inline', 'link', 'list'],
  inline: {
    options: ['bold', 'italic', 'strikethrough'],
    bold: {
      icon: boldTextIcon,
      className: styles.bns3_tollbar_item,
    },
    italic: {
      icon: italicTextIcon,
      className: styles.bns3_tollbar_item,
    },
    strikethrough: {
      icon: strikethroughTextIcon,
      className: styles.bns3_tollbar_item,
    },
  },
  colorPicker: {
    icon: textColorIcon,
    className: styles.bns3_tollbar_item,
    popupClassName: styles.bns3_toolbar_item_dropdown,
  },
  link: {
    popupClassName: styles.bns3_toolbar_item_dropdown,
    link: {
      icon: hyperlinkIcon,
      className: styles.bns3_tollbar_item,
    },
    unlink: {
      icon: hyperlinkUnlinkIcon,
      className: styles.bns3_tollbar_item,
    },
  },
  list: {
    options: ['unordered', 'ordered'],
    ordered: {
      icon: listOrderedIcon,
      className: `${styles.bns3_tollbar_item} ${styles.bns3_tollbar_item_ordered}`,
    },
    unordered: {
      icon: listUnorderedIcon,
      className: `${styles.bns3_tollbar_item} ${styles.bns3_tollbar_item_unordered}`,
    },
  },
};
